import { render } from "./SelectMailboxModal.vue?vue&type=template&id=10f1b4fc&scoped=true"
import script from "./SelectMailboxModal.vue?vue&type=script&lang=js"
export * from "./SelectMailboxModal.vue?vue&type=script&lang=js"

import "./SelectMailboxModal.vue?vue&type=style&index=0&id=10f1b4fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f1b4fc"]])

export default __exports__